import { render, staticRenderFns } from "./TacticFilters.vue?vue&type=template&id=4e0f05e2"
import script from "./TacticFilters.vue?vue&type=script&lang=ts"
export * from "./TacticFilters.vue?vue&type=script&lang=ts"
import style0 from "./TacticFilters.vue?vue&type=style&index=0&id=4e0f05e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports